// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1530":"5cd13c5b","3525":"d09e0efe","6013":"2dff1aec"}[chunkId] + ".css";
};